class VariantPicker extends HTMLElement {
  connectedCallback() {
    const variantJson = this.querySelector('[data-variant-json]');
    this.variants = variantJson ? JSON.parse(variantJson.textContent) : [];
    this.priceData = null;

    this.querySelectorAll('.variant-picker__radio').forEach((radio) => {
      radio.addEventListener('change', () => {
        const valueLabel = radio.closest('.variant-picker__option').querySelector('.variant-picker__value');
        if (valueLabel) valueLabel.textContent = ': ' + radio.value;
        this.onOptionChange();
      });
    });
  }

  getSelectedOptions() {
    const groups = new Map();
    this.querySelectorAll('.variant-picker__radio:checked').forEach((radio) => {
      groups.set(Number(radio.dataset.optionIndex), radio.value);
    });
    return Array.from(groups.keys())
      .sort((a, b) => a - b)
      .map((index) => groups.get(index));
  }

  findVariant(selectedOptions) {
    return this.variants.find((variant) =>
      variant.options.every((value, index) => value === selectedOptions[index])
    );
  }

  onOptionChange() {
    const variant = this.findVariant(this.getSelectedOptions());
    this.updateURL(variant);
    this.updateMedia(variant);
    this.updatePrice(variant);
    this.updateButton(variant);
  }

  updateURL(variant) {
    if (!variant) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  updateMedia(variant) {
    if (!variant || !variant.featured_media) return;
    const gallery = this.querySelector('product-gallery');
    if (gallery) gallery.showMedia(variant.featured_media.id);
  }

  loadPriceData() {
    if (this.priceData) return this.priceData;
    const script = this.querySelector('[data-variant-prices]');
    this.priceData = script ? JSON.parse(script.textContent) : {};
    return this.priceData;
  }

  updatePrice(variant) {
    const priceDisplay = this.querySelector('price-display');
    if (!priceDisplay || !variant) return;
    const data = this.loadPriceData()[variant.id];
    if (!data) return;
    if (data.compare_at_price) {
      priceDisplay.innerHTML =
        '<span class="price price--sale">' +
        '<span class="visually-hidden">' + this.dataset.regularPriceLabel + '</span>' +
        '<s class="price__compare-at">' + data.compare_at_price + '</s> ' +
        '<span class="visually-hidden">' + this.dataset.salePriceLabel + '</span>' +
        '<span class="price__sale">' + data.price + '</span></span>';
    } else {
      priceDisplay.innerHTML =
        '<span class="price">' +
        '<span class="visually-hidden">' + this.dataset.regularPriceLabel + '</span>' +
        '<span class="price__regular">' + data.price + '</span></span>';
    }
    const stickyPrice = document.querySelector('[data-sticky-bag-price]');
    if (stickyPrice) stickyPrice.textContent = data.price;
  }

  updateButton(variant) {
    const input = this.querySelector('[data-variant-id-input]');
    const button = this.querySelector('[data-add-to-cart-button]');
    if (input) input.value = variant ? variant.id : '';
    if (!button) return;
    if (!variant) {
      button.disabled = true;
      button.textContent = this.dataset.unavailableLabel;
      return;
    }
    button.disabled = !variant.available;
    button.textContent = variant.available ? this.dataset.addToCartLabel : this.dataset.soldOutLabel;
  }
}

customElements.define('variant-picker', VariantPicker);
